/**
 * Plan & Usage — colors from product design that are not yet on the MUI palette.
 * Prefer `theme.palette.*` in components where values match (e.g. heat empty ≈ background.default).
 */
export const PLAN_USAGE = {
  heatMapSurface: '#F7F4F2',
  heatEmpty: '#F0EAE5',
  heatLow: '#C5ECB2',
  heatMid: '#56C364',
  heatHigh: '#11865B',
  actionOutlineBorder: '#DBCFC3',
  progressFill: '#3F801C',
  monthAxis: 'rgba(63, 63, 63, 0.5)',
  weekdayAxis: 'rgba(89, 115, 147, 0.5)',
  footerMuted: '#959595',
}
